export default "__VITE_ASSET__C_98vXx1__"